export const SIZE_ORDER = ['S', 'M', 'L', 'XL', 'XXL'];